import { render, staticRenderFns } from "./EditViewModal.vue?vue&type=template&id=552c28c7&scoped=true"
import script from "./EditViewModal.vue?vue&type=script&lang=js"
export * from "./EditViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552c28c7",
  null
  
)

export default component.exports